import React from "react";
import { Loader, StyledPageWrapper, Title } from "@monorepo/components";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { useClientInfoQuery } from "@monorepo/services/api/auth";
import { useServicesByCategoryQuery } from "@monorepo/services/api/services";
import { ServiceCategoryIdEnum } from "@monorepo/types";
import { reverse } from "named-urls";

import ServiceListAutocomplete from "components/ServiceListAutocomplete/ServiceListAutocomplete";
import { PageWrapper } from "components/Services/ServicesPage";

interface IServicesByCategoryId {
  id: ServiceCategoryIdEnum;
}

const ServicesByCategory: React.FC<IServicesByCategoryId> = ({ id }) => {
  const { data: clientInfo } = useClientInfoQuery({ skipInitialLoad: false });
  const title = clientInfo?.fast_menu.find((item) => item.id === id)?.title;
  const { data: servicesByCategoryId, isLoading: isServicesLoading } = useServicesByCategoryQuery(id);

  if (isServicesLoading || !servicesByCategoryId) {
    return <Loader />;
  }

  return (
    <StyledPageWrapper>
      <PageWrapper>
        <Title>{title}</Title>
        <ServiceListAutocomplete
          divided
          pathToPush={(serviceId) =>
            reverse(routeConfig.dashboard.services.category.categoryId.service.serviceId, {
              categoryId: id,
              serviceId: serviceId,
            })
          }
          categoryId={id}
        />
      </PageWrapper>
    </StyledPageWrapper>
  );
};

export default ServicesByCategory;
